"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapShoppingBagItem = mapShoppingBagItem;
var _checkoutUtils = require("@ori/checkout-utils");
var _tsUtils = require("@ori/ts-utils");
function determineIfIsOfferItem(item, commonProps, flagLabelClass) {
  return (0, _checkoutUtils.isNullableStringAGreaterThanB)(item.basicCataloguePrice, item.price) || flagLabelClass.includes('offer') || Boolean(commonProps.isDiscounted);
}
function mapShoppingBagItem(props) {
  const {
    item,
    commonProps
  } = props;
  const flag = (0, _tsUtils.isNonNullable)(item.productFlag) ? {
    label: item.productFlag.label,
    labelClass: item.productFlag.labelClass,
    tooltip: item.productFlag.tooltip
  } : undefined;
  const flagLabelClass = flag?.labelClass ?? 'no';
  const theItemIsOfferItem = determineIfIsOfferItem(item, commonProps, flagLabelClass);
  const shade = (0, _checkoutUtils.stringEmptyToUndefined)(item.colorHexCode) === undefined && (0, _checkoutUtils.stringEmptyToUndefined)(item.colorImageSrc) === undefined ? undefined : {
    hexColors: item.colorHexCode?.split(',').filter(hexCode => Boolean(hexCode)) ?? undefined,
    imageUrl: item.colorImageSrc ?? undefined,
    shadeName: (0, _checkoutUtils.stringEmptyToUndefined)(item.itemColor)
  };
  return {
    basicCataloguePrice: (0, _checkoutUtils.stringEmptyToUndefined)(item.basicCataloguePrice),
    bp: item.bp,
    brand: (0, _checkoutUtils.stringEmptyToUndefined)(item.itemBrand),
    bundleItems: undefined,
    buttons: undefined,
    bv: undefined,
    cataloguePrice: (0, _checkoutUtils.stringEmptyToUndefined)(item.price),
    code: item.itemCode,
    flags: flag === undefined ? undefined : [flag],
    image: (0, _checkoutUtils.stringEmptyToUndefined)(item.itemImageSrc),
    isAvailable: item.isAvailable,
    isOfferColor: theItemIsOfferItem,
    isSmall: true,
    lineNumber: item.lineNumber,
    maxQuantity: item.maxQuantity,
    minQuantity: item.canBeDeleted ? item.canBeReduced ? 0 : commonProps.initialQuantity : 1,
    name: item.itemDescription,
    points: (0, _checkoutUtils.stringEmptyToUndefined)(item.points),
    priceName: commonProps.isBrandPartner ? 'cataloguePrice' : 'regularPrice',
    quantity: item.quantity,
    quantityPickerDisabled: !item.isAvailable || !item.canBeModified,
    requestedQuantity: item.requestedQuantity,
    shade,
    showBp: false,
    testId: commonProps.testId,
    totalPrice: item.totalPrice,
    translations: commonProps.basketItemTranslations,
    translationsNamespace: commonProps.basketItemTranslationsNamespace,
    type: item.itemType,
    unitPrice: (0, _checkoutUtils.stringEmptyToUndefined)(item.unitPrice),
    url: (0, _checkoutUtils.stringEmptyToUndefined)(item.itemDetailPath)
  };
}
